import styled from "@emotion/styled";

export const StyledWrapper = styled.div({
  position: "relative",
  height: "100%",
  width: "100%",
});

export const StyledScrollable = styled.div({
  overflowY: "auto",
  scrollbarWidth: "none",
  width: "100%",
  height: "100%",

  "::-webkit-scrollbar": {
    display: "none",
  },
});

export const StyledVerticalScrollFade = styled.div<{
  $placement: "top" | "bottom";
  $visible?: boolean;
}>`
  position: absolute;
  left: 0;
  height: 28px;
  width: 100%;
  bottom: ${({ $placement }) => ($placement === "bottom" ? 0 : "auto")};
  top: ${({ $placement }) => ($placement === "top" ? 0 : "auto")};
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.surface.pane}00 0%,
    ${({ theme }) => theme.colors.surface.pane}DA 85.42%,
    ${({ theme }) => theme.colors.surface.pane} 100%
  );
  transform: ${({ $placement }) => ($placement === "top" ? "rotate(180deg)" : "none")};
  user-select: none;
  pointer-events: none;
  opacity: ${({ $visible = true }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;
